import React from 'react';
import { Box, Button, useTheme } from '@drivekyte/web-components';
import { useMedia } from '@drivekyte/ui';
import { useRouter } from 'next/router';
import WPTypography from '@/components/typography/typography';
import { CtaType, DiscountTile } from '@/pages/blog/types';

type ClaimDiscountProps = {
  data: DiscountTile;
};

const getStyles = (theme: any, ctaType: CtaType, backroundImage?: string) => ({
  content: {
    height: '100%',
    width: '100%',
    borderRadius: '3%',
    boxSizing: 'border-box' as any,
    padding: theme.spacings.large,
    background: backroundImage
      ? `url(${backroundImage}) no-repeat center center`
      : undefined,
    backgroundColor:
      ctaType === 'primary' ? theme.colors.tertiary : theme.colors.secondary,
    border:
      ctaType === 'primary'
        ? `1px solid ${theme.colors.tertiary}`
        : '1px solid #e0e0e0',
  },
});

const ClaimDiscount = (props: ClaimDiscountProps) => {
  const media = useMedia();
  const isMobile = media.xs;
  const router = useRouter();
  const [theme] = useTheme();

  const { headline, text, cta } = props.data;
  const backroundImage = cta?.backroundImage?.data?.attributes?.url;
  const styles = getStyles(theme, cta.type, backroundImage);

  const handlePress = () => {
    let url = cta.url;

    if (!url.startsWith('http')) {
      url = `https://${url}`;
    }

    if (cta.newTab) {
      window.open(url, '_blank');
    } else {
      router.push(url);
    }
  };

  return (
    <Box paddingTop="tiny" paddingBottom="medium" paddingHorizontal="tiny">
      <div style={styles.content}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          textAlign="left"
          height="100%"
        >
          <WPTypography
            variant="h2"
            color={cta.type === 'primary' ? 'secondary' : 'primary'}
            fontFamily="Gilroy"
            fontSize={isMobile ? 32 : 38}
            lineHeight={isMobile ? 40 : 46}
            fontWeight={700}
          >
            {headline}
          </WPTypography>
          <Box marginBottom={isMobile ? 'xxLarge' : 'medium'}>
            <WPTypography
              variant="h4"
              color={cta.type === 'primary' ? 'secondary' : 'quaternary'}
              fontFamily="Gilroy"
              fontSize={16}
              lineHeight={24}
              fontWeight={500}
            >
              {text}
            </WPTypography>
          </Box>
          <Button
            variant={cta.type === 'primary' ? 'primary-on-image' : 'primary'}
            size="small"
            onPress={handlePress}
          >
            {cta.text}
          </Button>
        </Box>
      </div>
    </Box>
  );
};

export default ClaimDiscount;
